import { AlertType } from "../../enums/AlertType";
import { Alert } from "../../interfaces/Alert";
export const ALERT_TIMESLOT_OPENING_HOURS: Alert = {
  type: AlertType.Error,
  title: {
    message: 'Error',
    translated: false,
  },
  message: {
    message: 'custom.opening_hours_required_to_set_timeslot',
    translated: true,
  },
};
